import { createAsyncThunk,createSlice } from '@reduxjs/toolkit';
import axios, { AxiosError } from 'axios';
import { parameterList, payloadParameterUpdate } from 'models/parameters';
import { reduxTemplate } from 'models/redux';
import { defaultResponse, rejectResponse } from 'models/response';

import { getListParameter, patchParameter } from './service';


export const getList = createAsyncThunk<
  parameterList,
  void,
  { rejectValue: rejectResponse }
>('parameter/list', async (_, { rejectWithValue }) => {
  try {
    const data = await getListParameter();
    return data;
  } catch (_error) {
    if (axios.isAxiosError(error)) {
      const err = error as AxiosError<rejectResponse>;
      return rejectWithValue(err.response?.data);
    }
    console.error(error);
  }
});

export const updateParameter = createAsyncThunk<
  defaultResponse,
  payloadParameterUpdate,
  { rejectValue: rejectResponse }
>('parameter/update', async (payload, { rejectWithValue }) => {
  try {
    const data = await patchParameter(payload);
    return data;
  } catch (_error) {
    if (axios.isAxiosError(error)) {
      const err = error as AxiosError<rejectResponse>;
      return rejectWithValue(err.response?.data);
    }
    console.error(error);
  }
});
interface IParameterReducer extends reduxTemplate {
  list: parameterList;
}

const initialState: IParameterReducer = {
  status: 'idle',
  message: '',
  type: '',
  list: {
    status: 'idle',
    message: '',
    rowsAffected: [],
    document: [],
  },
};

export const parametersReducer = createSlice({
  name: 'parameters',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getList.pending, (state, action) => {
        state.status = 'loading';
        state.type = action.type;
      })
      .addCase(getList.fulfilled, (state, action) => {
        state.status = 'completed';
        state.message = action.payload.message;
        state.list = action.payload;
        state.type = action.type;
      })
      .addCase(getList.rejected, (state, action) => {
        state.status = 'failed';
        state.type = action.type;
      });
  },
});
export default parametersReducer.reducer;
